import { AndroidPermissions } from "@ionic-native/android-permissions";
import { NgModule } from "@angular/core";
import { BasePageComponent } from "./base-page/base-page";
import { EventsFeedComponent } from "./events-feed/events-feed";
import { IonicModule } from "ionic-angular";
import { MyEventsComponent } from "./my-events/my-events";
import { BaseHeaderComponent } from "./base-header/base-header";
import { MessengerMessagesComponent } from "./messenger-messages/messenger-messages";
import { MessengerContactsComponent } from "./messenger-contacts/messenger-contacts";
import { MessengerPicksComponent } from "./messenger-picks/messenger-picks";
import { MessengerNotesComponent } from "./messenger-notes/messenger-notes";
import { MatchmakingComponent } from "./matchmaking/matchmaking";
import { MenuProfileComponent } from "./menu-profile/menu-profile";
import { MatchmakingPicksComponent } from "./matchmaking-picks/matchmaking-picks";
import { MatchmakingContactsComponent } from "./matchmaking-contacts/matchmaking-contacts";
import { PasswordStrengthBarModule } from "ng2-password-strength-bar";
import { ProfileInfoComponent } from "./profile-info/profile-info";
import { ProfileAboutComponent } from "./profile-about/profile-about";
import { ProfileAccountComponent } from "./profile-account/profile-account";
import { CustomFormsModule } from "ng2-validation";
import { InterestsComponent } from "./interests/interests";
import { EventWallComponent } from "./event-wall/event-wall";
import { QAndAComponent } from "./q-and-a/q-and-a";
import { SocialWallComponent } from "./social-wall/social-wall";
import { ImageCropperModule } from "ngx-image-cropper";
import { LinkyModule } from "angular-linky";
import { InlineSVGModule } from "ng-inline-svg";
import { Ng2FileInputModule } from "ng2-file-input";
import { AgendaComponent } from "./agenda/agenda";
import { BaseLoginComponent } from "./base-login/base-login";
import { EventNavigationButtonComponent } from "./event-navigation-button/event-navigation-button";
import { PipesModule } from "../pipes/pipes.module";
import { PrizeGameWallComponent } from "./prize-game-wall/prize-game-wall";
import { DirectivesModule } from "../directives/directives.module";
import { EventNavigationTabsComponent } from "./event-navigation-tabs/event-navigation-tabs";
import { EventDocumentsComponent } from "./event-documents/event-documents";
import { ExhibitorsComponent } from "./exhibitors/exhibitors";
import { ReadMoreComponent } from "./shared/read-more.component";
import { TruncateModule } from "ng2-truncate";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { YoutubeIframeComponent } from "./youtube-iframe/youtube-iframe";
import { CropModalComponent } from "./crop-modal/crop-modal";
import { EventTicketCodeComponent } from "./event-ticket-code/event-ticket-code";
import { EventTicketItemComponent } from "./event-ticket-item/event-ticket-item";
import { EventTicketScanComponent } from "./event-ticket-scan/event-ticket-scan";
import { EventTicketQrComponent } from "./event-ticket-qr/event-ticket-qr";
import { NgxQRCodeModule } from "ngx-qrcode3";
import { VideoIframeComponent } from "./video-iframe/video-iframe";
import { GoToBoothBtnComponent } from "./go-to-booth-btn/go-to-booth-btn";
import { QrCodeReaderComponent } from "./qr-code-reader/qr-code-reader";
import { ToastComponent } from './toast/toast';

@NgModule({
  declarations: [
    BasePageComponent,
    EventsFeedComponent,
    MyEventsComponent,
    BaseHeaderComponent,
    MessengerMessagesComponent,
    MessengerContactsComponent,
    MessengerPicksComponent,
    MessengerNotesComponent,
    MatchmakingComponent,
    MenuProfileComponent,
    MatchmakingPicksComponent,
    MatchmakingContactsComponent,
    ProfileInfoComponent,
    ProfileAboutComponent,
    ProfileAccountComponent,
    InterestsComponent,
    EventWallComponent,
    QAndAComponent,
    SocialWallComponent,
    AgendaComponent,
    BaseLoginComponent,
    EventNavigationButtonComponent,
    PrizeGameWallComponent,
    EventNavigationTabsComponent,
    EventDocumentsComponent,
    ExhibitorsComponent,
    ReadMoreComponent,
    CropModalComponent,
    YoutubeIframeComponent,
    EventTicketCodeComponent,
    EventTicketItemComponent,
    EventTicketScanComponent,
    EventTicketQrComponent,
    EventTicketScanComponent,
    VideoIframeComponent,
    GoToBoothBtnComponent,
    QrCodeReaderComponent,
    ToastComponent
  ],
  imports: [
    IonicModule,
    CustomFormsModule,
    PasswordStrengthBarModule,
    LinkyModule,
    // InlineSVGModule.forRoot({ baseUrl: 'https://192.168.0.150/matchabout2/' }),
    InlineSVGModule,
    ImageCropperModule,
    Ng2FileInputModule,
    PipesModule,
    DirectivesModule,
    TruncateModule,
    NgxQRCodeModule,
  ],
  exports: [
    BasePageComponent,
    EventsFeedComponent,
    MenuProfileComponent,
    ProfileInfoComponent,
    ProfileAboutComponent,
    ProfileAccountComponent,
    MyEventsComponent,
    BaseHeaderComponent,
    MessengerMessagesComponent,
    MessengerContactsComponent,
    MessengerPicksComponent,
    MessengerNotesComponent,
    MatchmakingComponent,
    MenuProfileComponent,
    MatchmakingPicksComponent,
    MatchmakingContactsComponent,
    ProfileInfoComponent,
    ProfileAboutComponent,
    ProfileAccountComponent,
    InterestsComponent,
    EventWallComponent,
    QAndAComponent,
    SocialWallComponent,
    ImageCropperModule,
    LinkyModule,
    InlineSVGModule,
    Ng2FileInputModule,
    AgendaComponent,
    BaseLoginComponent,
    EventNavigationButtonComponent,
    PrizeGameWallComponent,
    EventNavigationTabsComponent,
    EventDocumentsComponent,
    ExhibitorsComponent,
    ReadMoreComponent,
    CropModalComponent,
    YoutubeIframeComponent,
    EventTicketCodeComponent,
    EventTicketItemComponent,
    EventTicketScanComponent,
    EventTicketQrComponent,
    EventTicketScanComponent,
    VideoIframeComponent,
    GoToBoothBtnComponent,
    QrCodeReaderComponent,
    ToastComponent
  ],
  entryComponents: [CropModalComponent],
  providers: [AndroidPermissions],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts